import InstIcon from '../assets/images/channel-inst.png';
import TelegramIcon from '../assets/images/channel-telegram.png';
import WhatsappIcon from '../assets/images/channel-whatsapp.png';
import FbIcon from '../assets/images/channel-fb.png';
import ViberIcon from '../assets/images/channel-viber.png';
import SmsIcon from '../assets/images/channel-sms.png';
import VkCommIcon from '../assets/images/channel-vk.png';
import VkGroupIcon from '../assets/images/channel-vkgroup.png';
import LivechatIcon from '../assets/images/channel-livechat.png';
import SmsMoneyIcon from '../assets/images/channel-smsMoney.png';
import OkIcon from '../assets/images/channel-ok.png';

export const iconsSources = {
  sms: SmsIcon,
  facebook: FbIcon,
  vkgroup: VkGroupIcon, // сообщение вк
  telegram: TelegramIcon,
  telegrambot: TelegramIcon,
  viber: ViberIcon,
  whatsapp: WhatsappIcon,
  livechat: LivechatIcon,
  fbinstagram: InstIcon,
  vkcomments: VkCommIcon, // повторение
  facebookcomments: FbIcon,
  smsMoney: SmsMoneyIcon,
  vk: VkCommIcon, // комментарий вк
  vkcomm: VkCommIcon, // комментарий вк
  ok: OkIcon,
  okgroup: OkIcon,
};
